import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import firebase from 'firebase';
import reactfire from 'reactfire';
import base from './base.js';
import axios from 'axios';

//Load our modules
import Home from './routes/Home';

class App extends Component {
  constructor() {
    super();
    this.authenticate = this.authenticate.bind(this);
    this.logout = this.logout.bind(this);
    this.authHandler = this.authHandler.bind(this);
    this.bungieAuth = this.bungieAuth.bind(this);
    this.state = {
      user: null
    };
  }
  componentDidMount() {
    // check for the state of the authentication
    // firebase.auth().getRedirectResult().then(function(result) {
    //   // only runs after a user just signs in
    //  // result will be blank if the user is only refreshing
    //   // returns an object, which contains a user object
    //   console.log('Logging the result of the redirect auth');
    //   console.log(result);
    //   if(result){
    //     // run code here that needs to be run when a user manually logs in
    //   }

    // });
    firebase.auth().onAuthStateChanged(result => {
      if (result) {
        this.authHandler(result);
      }
    });
  }
  authenticate(provider) {
    console.log(`trying to authenticate with ${provider}`);
    if (provider === 'phone') {
    }
    if (provider === 'twitter') {
      const twProvider = new firebase.auth.TwitterAuthProvider();
      firebase.auth().signInWithRedirect(twProvider);
    }
    if (provider === 'Bungie') {

      this.bungieAuth();
    }
  }
  logout() {
    firebase.auth().signOut();
    this.setState({ user: null });
    console.log(`logged out`);
  }
  authHandler(user) {
    this.setState({ user });
    console.log('auth handler');
  }

  bungieAuth() {
    console.log(`starting the bungieAuth`);
    axios({
      mehod: 'get',
      url: 'https://www.towerloadout.com/api/auth/bungie/'
    })
      .then(function(response){
        console.log(response);
      })
      .catch(function(error){
        console.log(error);
      });
  }

  render() {
    const logOut = <button onClick={() => this.logout()}>Logout</button>;

    return (
      <Router>
        <div className="App">
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <h1 className="App-title">Welcome to React</h1>
          </header>
          <p className="App-intro">
            To get started, edit <code>src/App.js</code> and save to reload.
          </p>
          <button onClick={() => this.authenticate('phone')}>
            Authenticate w phone
          </button>
          <button onClick={() => this.authenticate('bungie')}>Bungie</button>
          <button onClick={() => this.authenticate('twitter')}>
            Authenticate w twitter
          </button>
          {logOut}
        <Switch>
          <Route exact path="/" component={Home} />
          <Route component={Home} />
        </Switch>
        </div>

      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js